import { SearchType } from '@aibees/elephant/types';
import { LabelGrouping } from '@aibees/elephant/types/label';
import { useMemo } from 'react';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';
import { usePageType } from '../use-page-type';

export function useLabelGroupingStatus(searchType?: SearchType) {
  const type = useSearchTypeFromRoute();
  const { isPeoplePage } = usePageType();

  return useMemo(() => {
    return (searchType || type) === SearchType.People || isPeoplePage
      ? LabelGrouping.PEOPLE
      : LabelGrouping.COMPANY;
  }, [isPeoplePage, type, searchType]);
}
